import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ScrollToTop } from "./ScrollToTop";
import { SearchDialog } from "@/components/search/SearchDialog";
import { BookButton } from "@/components/common/BookButton";
import { Ticket } from "lucide-react";

export const Layout = () => {
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setSearchOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-travertine">
      <ScrollToTop />
      <Navbar onOpenSearch={() => setSearchOpen(true)} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <SearchDialog open={searchOpen} onOpenChange={setSearchOpen} />

      {/* Mobile sticky booking bar */}
      <div className="fixed inset-x-0 bottom-0 z-40 border-t border-stone-line bg-travertine/95 px-4 py-3 backdrop-blur-xl sm:hidden">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 text-sm">
            <Ticket size={18} className="text-gold-dark" />
            <span className="font-medium text-charcoal">Colosseum tickets</span>
          </div>
          <BookButton label="Book Now" size="sm" className="ml-auto" testId="mobile-sticky-book" />
        </div>
      </div>
      <div className="h-16 sm:hidden" aria-hidden="true" />
    </div>
  );
};

export default Layout;
